module.exports = __webpack_public_path__ + "img/house20B.c16bdc22.svg";